import noop from 'lodash/noop';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { StoreApi, OpenArchiveIssueModalProps } from './types.tsx';

export const ArchiveIssueModalActions = {
	openArchiveIssueModal:
		({
			issueKey,
			issueId,
			onIssueArchiveSuccess,
			onChildIssuesArchiveSuccess,
			onDeleteIssuesFromNINView,
			onCloseIssueViewModal,
			triggerPointKey,
			workType,
			issueHierarchyLevel,
		}: OpenArchiveIssueModalProps) =>
		({ setState }: StoreApi): void => {
			setState({
				isArchiveIssueModalOpen: true,
				issueKey,
				issueId,
				onIssueArchiveSuccess,
				onChildIssuesArchiveSuccess,
				onDeleteIssuesFromNINView: expVal('child-issue-archival-ga', 'isEnabled', false)
					? onDeleteIssuesFromNINView
					: noop,
				onCloseIssueViewModal,
				triggerPointKey,
				workType,
				issueHierarchyLevel,
			});
		},
	closeArchiveIssueModal:
		() =>
		({ setState }: StoreApi): void => {
			setState({
				isArchiveIssueModalOpen: false,
				issueKey: null,
				issueId: null,
				onIssueArchiveSuccess: null,
				onChildIssuesArchiveSuccess: null,
				onDeleteIssuesFromNINView: noop,
				onCloseIssueViewModal: null,
				triggerPointKey: null,
				workType: null,
			});
		},
};

export type Actions = typeof ArchiveIssueModalActions;
